import {
  QueryFormData,
  JsonObject,
  Nullable,
  isDefined,
} from '@superset-ui/core';

export default function extractMatchRecognize(
  formData: QueryFormData,
): Nullable<JsonObject> {
  const {
    match_recognize_configs: configs,
    match_recognize_partition_by: partitionBy,
    match_recognize_order_by: orderBy,
    show_match_number,
    show_match_sequence_number,
  } = formData;
  if (!isDefined(partitionBy) || !isDefined(orderBy)) {
    return null;
  }

  const measures = [];
  if (show_match_number) {
    measures.push(['MATCH_NUMBER()', 'match_number']);
  }
  if (show_match_sequence_number) {
    measures.push(['MATCH_SEQUENCE_NUMBER()', 'match_sequence_number']);
  }

  return {
    match_recognize: {
      configs,
      partition_by: partitionBy,
      order_by: orderBy,
      measures,
    },
  };
}
